import Header from "./Header";
import Parallax from "./Parallax";
import Fv from "./Fv";
import Place from "./Place";
import Program from "./Program";
import Communicate from "./Communicate";
import Modal from "./Modal";
import Schools from "./Schools";
import SlideToggle from "./SlideToggle";
import GlobalNav from "./GlobalNav";

(function() {
  const requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame
  window.requestAnimationFrame = requestAnimationFrame
})()

class ScienceCafeApp
{
  // ---------------------------------------------------------------------------------------------------------
	// --	App
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    // debugパラメータ指定がない場合は、console.log 出力を行わないように
    if (!this.getParam('debug'))
    {
      console.log = function () {
          // do nothing.
      }
    }
    console.log('ScienceCafeApp')

    //VIEWPORTの設定
    var ua = navigator.userAgent
    if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
      $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no">')
    } else {
      $('head').prepend('<meta name="viewport" content="width=1280, target-densitydpi=device-dp, user-scalable=no, shrink-to-fit=no">')
    }

    //準備完了
    $(document).ready(this.onReady.bind(this));   

    //ロード完了
    this.isLoaded = false
    $(window).on('load', ()=>{
      this.isLoaded = true
      this.onLoad()
    })
  }

  /**
   * 準備完了
   */
  onReady()
  {
    console.log('onReady')

    //スライドトグルコンテンツの準備
    $('.js-slide-toggle').each(function(){
      new SlideToggle($(this))
    })
  }

  /**
   * Load完了
   */
  onLoad()
  {
    console.log('onLoad')

    //PAGETOPボタン
    $('.sc-footer__page-top').click((e) => {
      e.preventDefault()
      $('body, html').animate({scrollTop: 0}, 1000)
      return false
    })

    //TOP
    this.isTop = false
    if($('.sciencecafe-top').length)
    {
      this.isTop = true
      this.initTop()
    }

    //GLOBAL NAV
    new GlobalNav();

    //MODAL
    if($('.sc-modal').length) new Modal()

    //日本地図の初期化
    if($('.sciencecafe-schools').length)
    {
      new Schools()
    }

    //フェードイン
    const fader = $('.sc-fader')
    gsap.to(fader, 0.5, {
      alpha:0,
      delay:0.5,
      ease:'none',
      onStart:()=>{
        if(this.isTop) this.fv.showMV()
      },
      onComplete:()=>{
        fader.remove()
        if(this.isTop) this.start()
      }
    })
  }

  start()
  {
    //コピー表示
    this.fv.showCopy()

    //アップデート開始
    this.update()
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	初期化
	// ---------------------------------------------------------------------------------------------------------

  initTop()
  {
    //ヘッダー
    new Header()

    //パララックス効果
    new Parallax()

    //FV
    this.fv = new Fv()

    //Place
    this.place = new Place()

    //Program
    this.program = new Program()

    //Communicate
    this.communicate = new Communicate()
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	ループ処理
	// ---------------------------------------------------------------------------------------------------------

  /**
   * アップデート
   */
  update()
  {
    //アップデート
    if(this.place) this.place.update()
    if(this.communicate) this.communicate.update()

    //loop
    requestAnimationFrame(this.update.bind(this))
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	UTIL
	// ---------------------------------------------------------------------------------------------------------

  getParam(key, url) 
  {
    if (!url) url = window.location.href;
    key = key.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // ---------------------------------------------------------------------------------------------------------
}

new ScienceCafeApp()
